<!-- 模块-单个优惠券 -->
<template>
  <div class="card_back" :style="{ 'background-image': 'url(' + (bg_img) + ')'}">
    <van-row class="left" >
      <van-col span="24" style="font-size:22px">{{data.money}}{{txt}}</van-col>
      <van-col span="24" style="font-size:12px">{{data.explain}}</van-col>
      <van-col span="24" class="line"></van-col>
      <van-col span="24" style="font-size:12px" v-if="data.date"> {{data.date[0]}} - {{data.date[1]}}</van-col>
    </van-row>
    <van-row class="rigth" :style="{color: txt_color}">
      <van-col span="24" style="font-size:22px; margin-bottom: 30px;">￥{{data.money}}</van-col>
      <van-col span="24" style="font-size:14px">满{{data.trigger}}元可用</van-col>
    </van-row>

  </div>
</template>

<style lang="scss" scoped>
  .card_back {
    width: 100%;
    height: 125px;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    text-align: center;
    color: #FFF;
    box-shadow: -5px 2px 5px 0 rgba(0,0,0,.1);

    .left {
      width: 60%;

      .line{
        width: 80%;
        border: dotted 1px white;
        position: relative;
        left: 20px;
        margin: 5px 0;
      }
    }

    .rigth {
      width: 40%;
      line-height: 0px;
    }
  }
</style>

<script>
export default {
  name: 'coupons_template',
  props: ['data'],
  data () {
    return {
      txt: '',
      bg_img: '',
      txt_color: ''
    }
  },

  watch: {
    data () {
      this.set_style()
    }
  },

  created () {
    this.set_style()
  },

  methods: {
    // 按类型和状态出来样式
    set_style () {
      switch (this.data.type) {
        case 1:
          this.txt = '元满减券'
          this.bg_img = require('@/assets/coupon_one.png')
          this.txt_color = '#0081ff'
          break

        case 2:
          this.txt = '元满减券'
          this.bg_img = require('@/assets/coupon_two.png')
          this.txt_color = '#6739b6'
          break

        case 3:
          this.txt = '元满减券'
          this.bg_img = require('@/assets/coupon_three.png')
          this.txt_color = '#e03997'
          break

        case 4:
          this.txt = '元满减券'
          this.bg_img = require('@/assets/coupon_four.png')
          this.txt_color = '#39b54a'
          break
      }

      if (this.data.status === 2) {
        this.bg_img = require('@/assets/used.png')
        this.txt_color = '#0081ff'
      } else if (this.data.status === 3) {
        this.bg_img = require('@/assets/expired.png')
        this.txt_color = '#0081ff'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/discount/coupons_template.vue